import { ROUTES } from "../../../module/constants";
import { generalConst } from "../../../module/globalInterface";

export const EXTERNAL_PORTAL_URLS: generalConst = {
  BASE_URL: ROUTES.EXTERNAL_PORTAL,
  STEP_TWO: `${ROUTES.EXTERNAL_PORTAL}/stepTwo`,
  USERS_MANAGEMENT_STEP_ONE: `${ROUTES.EXTERNAL_PORTAL}/usersManagement/stepOne`,
  USERS_MANAGEMENT_STEP_TWO: `${ROUTES.EXTERNAL_PORTAL}/usersManagement/stepTwo`,
  USERS_MANAGEMENT_ADD_USER: `${ROUTES.EXTERNAL_PORTAL}/usersManagement/addUser`,
  SOCIETY_VALIDATION: `${ROUTES.EXTERNAL_PORTAL}/societyValidation`,
};

export const STATE_IDENTIFIER = {
  STEP_ONE: "stepOne",
  USERS_MANAGEMENT: "usersManagement",
  COMPACTED_USERS: "compactedUsers",
  REQUEST_STATE: "responseState",
  SELECTED_USERS: "selectedUsers",
  ROLES: "roles",
  SELECTED_ROLE: "selectedRole",
  STEP_TWO: "stepTwo",
  USER_DETAIL: "userDetail",
  SOCIETY_VALIDATION: "societyValidation",
  USERS: "users",
  OFFICES: "offices",
  COMPANIES: "companies",
  ADD_USER: "addUser",
  ALREADY_EXISTING_FISCAL_CODE: "alreadyExistingFiscalCode",
  FIELD_VISIBILITY: "fieldVisibility",
  BUTTONS: "buttons",
  MANAGERS: "managers",
  REFERRALS: "referrals",
  ORGANIZATIONAL_UNITS: "organizationalUnits",
  OU_SELECTED_ROLES: "ouSelectedRoles",
  COMBO_OPTIONS: "comboOptions",
  CLUSTER: "cluster",
  CONTRACT_TYPOLOGY: "contractTypology",
  FTE: "fte",
  PRESENCE: "presence",
  REACTIVATE_RENEW_ADMIN_BODY: "reactivateRenewAdminBody",
  REACTIVATE_RENEW_MASSIVE_BODY: "reactivateRenewMassiveBody",
  ADD_USER_RESPONSE_STATE: "addUserResponseState",
  ATTACHMENTS: "attachments",
  ADMIN_LETTERS: "adminLetters",
  USER_TYPES_THAT_CAN_BE_CREATED: "userTypesThatCanBeCreated",
  MANIPOLATED_OU: "manipolatedOu",
  FAILED_OPERATIONS: "failedOperations",
  USERS_WITH_SAME_FISCAL_CODE_MANAGER: "usersWithSameFiscalCodeManager",
};

export const LIST_IDENTIFIER: string = "list";
export const LOADER_IDENTIFIER: string = "loader";

export interface IFieldVisibility {
  fieldCode: string;
  roleId: string;
  fieldPermission: string;
}

export interface IComboOption {
  field: string;
  name: string;
  description: string;
  value: string;
  defaultValue: boolean;
}

export interface ICreateUserBody {
  companyExists?: boolean;
  id?: string | null;
  userCode?: string | null;
  ou?: string | null;
  userType?: string | null;
  name?: string;
  surname?: string;
  fiscalCode?: string;
  isDisabled?: boolean | null;
  isDeleted?: boolean | null;
  email?: string | null;
  dipenId?: string | null;
  dipenIdSec?: string | null;
  companyId?: string | null;
  companyDesc?: string | null;
  adUser?: string | null;
  siteId?: string | null;
  siteDesc?: string | null;
  statusId?: string | null;
  statusDesc?: string | null;
  relationshipStartDate?: string | null;
  relationshipEndDate?: string | null;
  terminationDate?: string | null;
  userId?: string | null;
  companyEmail?: string | null;
  area?: string | null;
  referral?: string | null;
  manager?: string | null;
  badge?: string | null;
  badgeRequestDate?: string | null;
  badgeReleaseDate?: string | null;
  badgeNote?: string | null;
  hasRequestedAD?: boolean | null;
  hasRequestedDB?: boolean | null;
  hasRequestedNexiEmail?: boolean | null;
  usernameNexi?: string | null;
  extensionTicketDate?: string | null;
  terminationTicketDate?: string | null;
  terminationNote?: string | null;
  genericNote?: string | null;
  hasRequestedWiFi?: boolean | null;
  externalCompanyId?: string | null;
  externalCompanyDesc?: string | null;
  contractType?: string | null;
  onSiteRate?: string | null;
  project?: string | null;
  cluster?: string | null;
  amministratoreSistema?: boolean | null;
  scadenzaLetteraNomina?: string | null;
  amministratoreApparSic?: boolean | null;
  datiMovEconomiche?: boolean | null;
  letteraInviata?: boolean | null;
  datiAnagrafici?: boolean | null;
  noteGenGovernance?: string | null;
  letteraFirmata?: boolean | null;
  amministratoreAppaRete?: boolean | null;
  datiCartePagamento?: boolean | null;
  noteProfiloAccDb?: string | null;
  adendDate?: string | null;
  adinitTicket?: string | null;
  adrenewTicket?: string | null;
  fte?: string | null;
  adterminationTicket?: string | null;
  mobileNumber?: string | null;
  vendorUser?: boolean;
}

export interface IUpdateUserBody {
  companyExists?: boolean;
  id?: string | null;
  userCode?: string | null;
  ou?: string | null;
  userType?: string | null;
  name?: string | null;
  surname?: string | null;
  fiscalCode?: string | null;
  isDisabled?: boolean | null;
  isDeleted?: boolean | null;
  email?: string | null;
  dipenId?: string | null;
  dipenIdSec?: string | null;
  companyId?: string | null;
  companyDesc?: string | null;
  adUser?: string | null;
  siteId?: string | null;
  siteDesc?: string | null;
  statusId?: string | null;
  statusDesc?: string | null;
  relationshipStartDate?: string | null;
  relationshipEndDate?: string | null;
  terminationDate?: string | null;
  userId?: string | null;
  companyEmail?: string | null;
  area?: string | null;
  manager?: string | null;
  referral?: string | null;
  badge?: string | null;
  badgeRequestDate?: string | null;
  badgeReleaseDate?: string | null;
  badgeNote?: string | null;
  hasRequestedAD?: boolean | null;
  hasRequestedDB?: boolean | null;
  hasRequestedNexiEmail?: boolean | null;
  hasRequestedSO?: boolean | null;
  usernameNexi?: string | null;
  extensionTicketDate?: string | null;
  terminationTicketDate?: string | null;
  terminationNote?: string | null;
  genericNote?: string | null;
  hasRequestedWiFi?: boolean | null;
  externalCompanyId?: string | null;
  externalCompanyDesc?: string | null;
  contractType?: string | null;
  onSiteRate?: string | null;
  project?: string | null;
  cluster?: string | null;
  amministratoreSistema?: boolean | null;
  scadenzaLetteraNomina?: string | null;
  amministratoreApparSic?: boolean | null;
  datiMovEconomiche?: boolean | null;
  letteraInviata?: boolean | null;
  datiAnagrafici?: boolean | null;
  noteGenGovernance?: string | null;
  letteraFirmata?: boolean | null;
  amministratoreAppaRete?: boolean | null;
  datiCartePagamento?: boolean | null;
  noteProfiloAccDb?: string | null;
  adterminationTicket?: string | null;
  adrenewTicket?: string | null;
  adinitTicket?: string | null;
  fte?: string | null;
  adendDate?: string | null;
  mobileNumber?: string | null;
  vendorUser?: boolean;
}

export const patternMailValidator = new RegExp(
  /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i
);

export enum validMailDomains {
  NEXI = "@nexi.com",
  EXTERNAL_NEXI = "@external.nexi.com",
  NEXIGROUP = "@nexigroup.com",
  EXTERNAL_NEXIGROUP = "@external.nexigroup.com",
}

export enum IMillisecondsExternalPortalConditions {
  RELATIONSHIP_END_DATE_CONSULTANT_DIFFERENCE = "34187400000",
  RELATIONSHIP_END_DATE_OUTSOURCER = "4102354800000",
  RELATIONSHIP_END_DATE_DIFFERENCE = "34187400000",
  SINGLE_DAY_MILLISECONDS = "86400000",
  ONE_MINUTE_TO_MIDNIGHT_CONVERTER = "86399000",
}

export enum statusDescCode {
  CESSATO = "CESSATO",
  CESSATO_SECURITY = "CESSATO_SECURITY",
  SCADUTO = "SCADUTO",
  IN_SERVIZIO = "IN_SERVIZIO",
  IN_VALIDAZIONE = "IN VALIDAZIONE",
  NON_IN_SERVIZIO = "NON_IN_SERVIZIO",
  BLOCCATO_SECURITY = "BLOCCATO_SECURITY",
}

export enum statusIdCode {
  IN_SERVIZIO = "1",
  SCADUTO = "2",
  CESSATO_CONS = "3",
  CESSATO_SECURITY = "4",
  NON_IN_SERVIZIO_CONS = "5",
  IN_VALIDAZIONE = "6",
  CESSATO_OUTS = "8",
  BLOCCATO_SECURITY = "10",
  NON_IN_SERVIZIO_OUTS = "0",
}

export const statusCodeId = {
  "1": "IN_SERVIZIO",
  "2": "SCADUTO",
  "3": "CESSATO",
  "4": "CESSATO_SECURITY",
  "5": "NON_IN_SERVIZIO",
  "6": "IN_VALIDAZIONE",
  "8": "CESSATO",
  "10": "BLOCCATO_SECURITY",
  "0": "NON_IN_SERVIZIO",
};

export enum statusIdString {
  IN_SERVIZIO = "IN_SERVIZIO",
  IN_VALIDAZIONE = "IN_VALIDAZIONE",
  SCADUTO = "SCADUTO",
  CESSATO = "CESSATO",
  CESSATO_CONS = "CESSATO_CONS",
  CESSATO_SECURITY = "CESSATO_SECURITY",
  NON_IN_SERVIZIO = "NON_IN_SERVIZIO",
  NON_IN_SERVIZIO_CONS = "NON_IN_SERVIZIO_CONS",
  CESSATO_OUTS = "CESSATO_OUTS",
  BLOCCATO_SECURITY = "BLOCCATO_SECURITY",
  NON_IN_SERVIZIO_OUTS = "NON_IN_SERVIZIO_OUTS",
}

export enum typologyString {
  CONSULTANT = "CONSULTANT",
  OUTSOURCER = "OUTSOURCER",
}

export enum statusIdLowerCase {
  In_Servizio = "9",
  Non_In_Servizio = "11",
  Cessato = "8",
  in_Validazione = "6",
}

export enum languageCodes {
  ITALIAN = "it",
  ENGLISH = "en",
}

export enum rolesToRename {
  RESPONSABILE_PERSON = "Responsabile Person",
  RESPONSABILE_PERSON_ITA = "Responsabile",
  RESPONSABILE_PERSON_ENG = "Manager",
  REFERENTE = "Referente",
  REFERENTE_ITA = "Referente",
  REFERENTE_ENG = "Referral User",
}

export enum IComboOptionType {
  CLUSTER = "CLUSTER",
  CONTRACT_TYPOLOGY = "CONTRACT",
  FTE = "FTE",
  PRESENCE = "PRESENCE",
}

export enum IVisibilityFieldType {
  OBSCURED = "O",
  READ = "R",
  BYPASS = "B",
  WRITE = "W",
  HIDE = "H",
  MANDATORY = "M",
}

export enum ICreateFieldType {
  EXTERNAL_USER_TYPOLOGY = "C1",
  OUTSOURCER_OU = "C2",
  CONSULTANT_OU = "C3",
  CONSULTANT_SOCIETY = "C4",
  ACTIVITY_CLUSTER = "C5",
  PROJECT = "C6",
  PRESENCE = "C7",
  FTE = "C8",
  CONTRACT_TYPOLOGY = "C9",
  CONSULTANT_RELATIONSHIP_END_DATE = "C10",
  NEW_REPRESENTATIVE = "C11",
  GENERIC_NOTES = "C12",
  FISCAL_CODE = "C13",
  RELATIONSHIP_START_DATE = "C14",
  OUTSOURCER_RELATIONSHIP_END_DATE = "C15",
  ENTERPRISE_EMAIL = "C16",
  OUTSOURCER_SOCIETY = "C17",
  ACTIVITY_STATUS = "C18",
  AREA = "C19",
  RESPONSIBLE = "C20",
  REPRESENTATIVE = "C21",
  MOBILE = "C22",
  VENDOR_USER = "C23",
}

export enum IUserFieldType {
  ID_RAB = "U1",
  AVAILABLE_ACTIONS = "U2",
  EXTERNAL_USER_TYPOLOGY = "U3",
  SYSTEM_ADMINISTRATOR = "U4",
  ACTIVITY_CLUSTER = "U5",
  PROJECT = "U6",
  PRESENCE = "U7",
  FTE = "U8",
  CONTRACT_TYPOLOGY = "U9",
  REPRESENTATIVE = "U10",
  AD_GROUPS = "U11",
  OTHER_DATAS = "U12",
  NETWORK_SYSTEM_ADMINISTRATOR = "U13",
  SECURITY_SYSTEM_ADMINISTRATOR = "U14",
  DBA_ADMINISTRATOR = "U15",
  SO_ADMINISTRATOR = "U16",
  BADGE = "U17",
  FISCAL_CODE = "U18",
  RELATIONSHIP_END_DATE = "U19",
  RELATIONSHIP_START_DATE = "U20",
  BADGE_REQUEST_DATE = "U21",
  AD_ACCOUNT_EXPIRATION_DATE = "U22",
  TERMINATION_TICKET_DATE = "U23",
  EXTENSION_TICKET_DATE = "U24",
  REGISTRY_DATAS = "U25",
  PAYMENT_CARDS_DATA = "U26",
  ECONOMIC_TRANSACTIONS_DATA = "U27",
  ENTERPRISE_EMAIL = "U28",
  NEXI_EMAIL = "U29",
  AREA = "U30",
  DEPOBANK_ID = "U31",
  RESPONSIBLE = "U32",
  LOCATION = "U33",
  SOCIETY = "U34",
  ACTIVITY_STATUS = "U35",
  OU = "U36",
  ID_UPDATER_USER = "U37",
  SIGNED_LETTER = "U38",
  SENT_LETTER = "U39",
  BADGE_NOTES = "U40",
  TERMINATION_NOTES = "U41",
  GENERIC_NOTES = "U42",
  GOVERNANCE_GENERIC_NOTES = "U43",
  DB_ACCESS_PROFILE_NOTES = "U44",
  NEXI_EMAIL_REQUEST = "U45",
  AD_ACCOUNT_REQUEST = "U46",
  NEXI_WIFI_REQUEST = "U47",
  DESIGNATION_LETTER_EXPIRATIONS = "U48",
  ACTIVITY_STATUS_2 = "U49",
  AD_INIT_TICKET = "U50",
  AD_RENEWAL_TICKET = "U51",
  CREATION_DATE = "U52",
  MODIFY_DATE = "U53",
  USER_TYPE = "U54",
  NEXI_NETWORK_USERNAME = "U55",
  AD_TERMINATION_TICKET = "U56",
  FULLNAME = "U57",
  MOBILE = "U58",
  VENDOR_USER = "U59",
}

export enum IReactivateUserFieldType {
  ID_RAB = "R1",
  AVAILABLE_ACTIONS = "R2",
  EXTERNAL_USER_TYPOLOGY = "R3",
  SYSTEM_ADMINISTRATOR = "R4",
  ACTIVITY_CLUSTER = "R5",
  PROJECT = "R6",
  PRESENCE = "R7",
  FTE = "R8",
  CONTRACT_TYPOLOGY = "R9",
  REPRESENTATIVE = "R10",
  AD_GROUPS = "R11",
  OTHER_DATAS = "R12",
  NETWORK_SYSTEM_ADMINISTRATOR = "R13",
  SECURITY_SYSTEM_ADMINISTRATOR = "R14",
  DBA_ADMINISTRATOR = "R15",
  SO_ADMINISTRATOR = "R16",
  BADGE = "R17",
  FISCAL_CODE = "R18",
  RELATIONSHIP_END_DATE = "R19",
  RELATIONSHIP_START_DATE = "R20",
  BADGE_REQUEST_DATE = "R21",
  AD_ACCOUNT_EXPIRATION_DATE = "R22",
  TERMINATION_TICKET_DATE = "R23",
  EXTENSION_TICKET_DATE = "R24",
  REGISTRY_DATAS = "R25",
  PAYMENT_CARDS_DATA = "R26",
  ECONOMIC_TRANSACTIONS_DATA = "R27",
  ENTERPRISE_EMAIL = "R28",
  NEXI_EMAIL = "R29",
  AREA = "R30",
  DEPOBANK_ID = "R31",
  RESPONSIBLE = "R32",
  LOCATION = "R33",
  SOCIETY = "R34",
  ACTIVITY_STATUS = "R35",
  OU = "R36",
  ID_UPDATER_USER = "R37",
  SIGNED_LETTER = "R38",
  SENT_LETTER = "R39",
  BADGE_NOTES = "R40",
  TERMINATION_NOTES = "R41",
  GENERIC_NOTES = "R42",
  GOVERNANCE_GENERIC_NOTES = "R43",
  DB_ACCESS_PROFILE_NOTES = "R44",
  NEXI_EMAIL_REQUEST = "R45",
  AD_ACCOUNT_REQUEST = "R46",
  NEXI_WIFI_REQUEST = "R47",
  DESIGNATION_LETTER_EXPIRATIONS = "R48",
  ACTIVITY_STATUS_2 = "R49",
  AD_INIT_TICKET = "R50",
  AD_RENEWAL_TICKET = "R51",
  CREATION_DATE = "R52",
  MODIFY_DATE = "R53",
  USER_TYPE = "R54",
  NEXI_NETWORK_USERNAME = "R55",
  AD_TERMINATION_TICKET = "R56",
  FULLNAME = "R57",
  MOBILE = "R58",
}

export enum IExternalPortalUserType {
  CONSULTANT = "Consultant",
  OUTSOURCER = "Outsourcer",
}

export const EXTERNAL_PORTAL_STATUS_LIST = [
  {
    label: "IN_SERVIZIO",
    value: "IN_SERVIZIO",
  },
  {
    label: "IN_VALIDAZIONE",
    value: "IN_VALIDAZIONE",
  },
  {
    label: "SCADUTO",
    value: "SCADUTO",
  },
  {
    label: "CESSATO",
    value: "CESSATO",
  },
  {
    label: "CESSATO_SECURITY",
    value: "CESSATO_SECURITY",
  },
  {
    label: "NON_IN_SERVIZIO",
    value: "NON_IN_SERVIZIO",
  },
  {
    label: "BLOCCATO_SECURITY",
    value: "BLOCCATO_SECURITY",
  },
];

export const EXTERNAL_PORTAL_TYPOLOGY_LIST = [
  {
    label: "OUTSOURCER",
    value: "OUTSOURCER",
  },
  {
    label: "CONSULTANT",
    value: "CONSULTANT",
  },
];
